import { GomakePasswordInput, GomakeTextInput } from "@/components";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { IInputContainer } from "./interfaces";
import { useStyle } from "./style";
import { useMediaQuery } from "@mui/material";

const InputContainer = ({
  input,
  error,
  changeState,
  placeholder,
  handleKeyPress,
  value,
  passwordInputRef,
  passwordDefaultValue,
}: IInputContainer) => {
  const { t } = useTranslation();
  const { classes } = useStyle();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isPasswordField = input.type === "password";
  const fieldId = `gomake-login-${input.key}`;
  const fieldName = input.name;

  const onChangeState = (e: ChangeEvent<HTMLInputElement>) => {
    changeState(input.key, e.target.value);
  };
  return (
    <div style={classes.inputContainer} key={input.key}>
      <div style={classes.inputLbl}>{t(input.label)}</div>
      <div style={isMobile ? {} : classes.input}>
        {isPasswordField ? (
          <GomakePasswordInput
            uncontrolled
            inputRef={passwordInputRef}
            defaultValue={passwordDefaultValue}
            inputId={fieldId}
            name={fieldName}
            error={error}
            placeholder={placeholder}
            onKeyDown={handleKeyPress}
            feedback={false}
            toggleMask
            autoComplete="current-password"
          />
        ) : (
          <GomakeTextInput
            id={fieldId}
            name={fieldName}
            onChange={onChangeState}
            type={input.type}
            error={error}
            value={value}
            placeholder={placeholder}
            onKeyDown={handleKeyPress}
            autoComplete="username"
          />
        )}
      </div>
    </div>
  );
};
export { InputContainer };
